import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import CV from '../pages/CV.vue'
import Maker from '../pages/Maker.vue'
import Photographer from '../pages/Photographer.vue'
import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/photographer',
      name: 'Photographer',
      component: Photographer,

      icon: 'camera',
      title: 'Humanist Photographer',
      img: require('../assets/home/photographer.jpg')
    },
    {
      path: '/cv',
      name: 'CV',
      component: CV,

      icon: 'fa-briefcase',
      title: 'Product Mgr @ Google',
      img: require('../assets/home/manager.jpg')
    },
    {
      path: '/maker',
      name: 'Maker',
      component: Maker,

      icon: 'fa-lightbulb',
      title: 'Maker',
      img: require('../assets/home/maker.jpg')
    },
    {
      path: '/collectionner',
      name: 'collectionner',

      icon: 'fa-instagram',
      title: 'Street-Art Collectionner',
      img: require('../assets/home/collectionner.jpg'),
      beforeEnter() { var win = window.open('https://instagram.com/licryle', '_blank'); win.focus(); }
    }
  ]
})

router.afterEach((toRoute) => {
  let pageName = ''
  for (let i in router.options.routes) {
    let r = router.options.routes[i]
    if (toRoute.name == r.name && r.title != undefined) {
      pageName = ' | ' + r.title
    }
  }

  window.document.title = 'Cyrille Berliat' + pageName
  goTo(0)
})

export default router